import {
  getLicensesWithAssignedPermission,
  hasLicenseWithStatus,
} from "./LicenseUtils";

export const getUsePermeabilityFeedback = ({
  userLicenses = [],
  licensePermissionId,
  licenseStatus,
  feedbackTypes,
}) => {
  const licensesWithPermission = getLicensesWithAssignedPermission(
    userLicenses,
    licensePermissionId,
  );

  if (licensesWithPermission.length === 0) {
    return { type: null, messageKey: null };
  }

  if (hasLicenseWithStatus(licensesWithPermission, licenseStatus.active)) {
    return { type: null, messageKey: null };
  }

  if (hasLicenseWithStatus(licensesWithPermission, licenseStatus.expiringSoon)) {
    return {
      type: feedbackTypes.WARNING,
      messageKey: "advanceSettings.licenseExpiringSoonWarning",
    };
  }

  if (
    hasLicenseWithStatus(licensesWithPermission, licenseStatus.expired) ||
    hasLicenseWithStatus(licensesWithPermission, licenseStatus.terminated)
  ) {
    return {
      type: feedbackTypes.ERROR,
      messageKey: "advanceSettings.licenseWarning",
    };
  }

  return { type: null, messageKey: null };
};
